import { smooth, canUseDom } from '@sainsburys-tech/boltui-utils'

const scrollToAccordion = (toElement, reducedOffset = false) => {
  const hasStickyNavFooter = document.querySelector('.pdp-v2-main')
  const mobileOffset = hasStickyNavFooter ? 10 : 80
  const offset = !reducedOffset && window.matchMedia('only screen and (min-width: 768px)').matches ? 130 : mobileOffset
  smooth.scrollHere(document.querySelector(toElement), offset, 500)
}

const isAccordionOpen = idElement => {
  const accordionButton = canUseDom() && document.querySelector(`${idElement}`)?.querySelector('button')
  return accordionButton?.ariaExpanded === 'true'
}

const openAccordion = toElement => {
  const accordionElm = document.querySelector(toElement)
  if (!isAccordionOpen(toElement)) {
    setTimeout(() => accordionElm.querySelector('button').click(), 0)
  } else {
    scrollToAccordion(toElement)
  }
}

const closeAccordion = (idElement = '') => {
  const accordionElement = document.querySelector(idElement)
  if (accordionElement && isAccordionOpen(idElement)) {
    accordionElement.children[0].children[0].click()
  }
}

export { scrollToAccordion, openAccordion, closeAccordion, isAccordionOpen }
